

        jQuery(function() {
            var $module = jQuery('#m-1526553338105').children('.module');
            $module.find('.counter').counterUp({
                delay: 10,
                time: 1000
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1526552895580').children('.module');

        }); 
    